const Constants = {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: '1366px',
    isMS: null,
    isIE: null
};

// Media Query checks
const MQ = {
    XS: window.matchMedia('(min-width: ' + Constants.xs + ')'),
    SM: window.matchMedia('(min-width: ' + Constants.sm + ')'),
    MD: window.matchMedia('(min-width: ' + Constants.md + ')'),
    LG: window.matchMedia('(min-width: ' + Constants.lg + ')'),
    XL: window.matchMedia('(min-width: ' + Constants.xl + ')')
};


export {
    Constants,
    MQ,
}